// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"table_tableContainer__9zFSv","articleTable":"table_articleTable__xNMRK"};